<!-- 数据分析主面板 -->
<template>
  <div class='uk-flex width-100'>
    <LineBarChart class='uk-flex-1' style='min-width: 400px;'></LineBarChart>
    <StatusEchart style='min-width: 300px; width: 350px;'></StatusEchart>
  </div>
</template>

<script>

import LineBarChart from './component/LineBarChart.vue'
import StatusEchart from './component/statusEchart.vue'

export default {
  components: {
    LineBarChart,
    StatusEchart
  }
}
</script>

<style></style>
